import { defineComponent as t, openBlock as n, createBlock as l, unref as a, mergeProps as i, withCtx as c, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconArrowDownRightInCircleFilled",
  __name: "IconArrowDownRightInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (s, e) => (n(), l(a(m), i(r, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        p("path", { d: "M12 21.75c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75m2.864-5.636a1.25 1.25 0 0 0 1.25-1.25v-4.571a.75.75 0 0 0-1.5 0v3.26L9.53 8.47a.75.75 0 1 0-1.06 1.06l5.084 5.084h-3.261a.75.75 0 0 0 0 1.5h4.571" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
